import { CircularLayout, CircularLayoutData, CircularLayoutEdgeRoutingPolicy, CircularLayoutOnCircleRoutingStyle, CircularLayoutRoutingStyle, CircularLayoutStyle, EdgeBundleDescriptor, PartitionStyle } from "yfiles";
import LayoutConfiguration from "./layoutConfiguration";
class CircularLayoutConfig extends LayoutConfiguration {
    createConfiguredLayout() {
        const layout = new CircularLayout({
            layoutStyle: CircularLayoutStyle.BCC_COMPACT,
            subgraphLayoutEnabled: false,
            fromSketchMode: false,
            partitionStyle: PartitionStyle.CYCLE,
            placeChildrenOnCommonRadius: false,
            hideGroupsStageEnabled: false,
            integratedNodeLabeling: false,
            considerNodeLabels: false,
            edgeRoutingPolicy: CircularLayoutEdgeRoutingPolicy.INTERIOR
        });
        const { balloonLayout } = layout;
        layout.singleCycleLayout.minimumNodeDistance = 30;
        layout.singleCycleLayout.automaticRadius = true;
        layout.singleCycleLayout.fixedRadius = 150;
        balloonLayout.minimumEdgeLength = 10;
        balloonLayout.compactnessFactor = 0.7;
        balloonLayout.minimumNodeDistance = 30;
        layout.defaultEdgeLayoutDescriptor.betweenCirclesRoutingStyle =
            CircularLayoutRoutingStyle.STRAIGHT;
        layout.defaultEdgeLayoutDescriptor.inCircleRoutingStyle = CircularLayoutRoutingStyle.STRAIGHT;
        layout.defaultEdgeLayoutDescriptor.onCircleRoutingStyle =
            CircularLayoutOnCircleRoutingStyle.STRAIGHT;
        layout.exteriorEdgeLayoutDescriptor.circleDistance = 20;
        layout.exteriorEdgeLayoutDescriptor.edgeToEdgeDistance = 10;
        layout.exteriorEdgeLayoutDescriptor.preferredCurveLength = 20;
        layout.exteriorEdgeLayoutDescriptor.preferredAngle = 5;
        layout.exteriorEdgeLayoutDescriptor.smoothness = 0.7;
        const ebc = layout.edgeBundling;
        ebc.bundlingStrength = 1.0;
        ebc.defaultBundleDescriptor = new EdgeBundleDescriptor({
            bundled: false
        });
        return layout;
    }
    createConfiguredLayoutData() {
        return new CircularLayoutData();
    }
}
export default CircularLayoutConfig;
